export const RENDERER_SUFFIX = '_renderer';
